import { FC } from "react";

import { DataIcon } from "../../../icons/DataIcon";
import { CloseIcon } from "../../../icons/CloseIcon";

import styles from "./Trial.module.css";



const Trial: FC = () => {
  return (
    <div className={styles["trial"]}>
      <h3 className={styles["trial__title"]}>
        <DataIcon />
        <span>We're collecting data for your AI score, stay tuned</span>
      </h3>
      <p className={styles["trial__close"]}>
        <span>7 days remaining in trial</span>
        <CloseIcon />
      </p>
    </div>
  );
};

export default Trial;
